<template>
  <div>
    <main class="main" role="main">
      <nav class="navbar navbar-lg navbar-expand-lg navbar-transparant navbar-absolute w-100 justify-content-end">
        <div class="dropdown">
          <button class="btn btn-outline-primary dropdown-toggle mr-2" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            {{$t('navbar.language')}}
          </button>
          <div class="dropdown-menu">
            <button class="dropdown-item" @click="changeLanguage('en')">
              {{$t('languageChoice.English')}}
            </button>
            <!--<button class="dropdown-item" @click="changeLanguage('zh')">
              {{$t('languageChoice.Chinese')}}
            </button>
            <button class="dropdown-item" @click="changeLanguage('jp')">
              {{$t('languageChoice.Japanese')}}
            </button>-->
          </div>
        </div>
      </nav>
      <div class="container pt-6">
        <div class="row align-items-center entire-screen">
          <div class="col-sm-10 col-md-8 col-lg-6 mx-auto my-4">
            <div class="text-center">
              <h1 class="h3">{{$t('login.welcome')}}</h1>
              <p class="lead">
                {{$t('login.explain')}}
              </p>
            </div>
            <div class="card">
              <div class="card-body">
                <div class="m-sm-4">
                  <form label-width="0px" class="demo-ruleForm pt-4 needs-validation" novalidate>
                    <p class="text-center" style="color:red" v-html="message"></p>
                    <div class="form-group">
                      <label for="email">{{$t('login.email')}}</label>
                      <input class="form-control form-control-lg" v-model="email" type="email" id="email" :placeholder="$t('login.emailPlaceholder')" required />
                      <div class="invalid-feedback">
                        {{$t('login.emailRequired')}}
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="password">{{$t('login.password')}}</label>
                      <input class="form-control form-control-lg" v-model="password" type="password" id="password" :placeholder="$t('login.passwordPlaceholder')" ref="password" required />
                      <div class="invalid-feedback">
                        {{$t('login.passwordRequired')}}
                      </div>
                    </div>
                    <small>
                      <a href="javascript:void(0);" data-toggle="modal" data-target="#forgetPasswordModal">{{$t('forgotPassword.forgotPasswordText')}}</a>
                    </small>
                    <div>
                      <!--
                      <div class="custom-control custom-checkbox align-items-center">
                        <input type="checkbox" class="custom-control-input" value="remember-me" name="remember-me" id="remember-me" checked>
                        <label class="custom-control-label text-small" for="remember-me">Remember me next time</label>
                      </div>-->
                    </div>
                    <div class="text-center mt-5">
                      <button type="submit" class="btn btn-lg btn-primary" @click="login">{{$t('login.login')}}</button>
                      <!-- <button type="submit" class="btn btn-lg btn-primary">Sign in</button> -->
                      <div class="text-center">
                        {{$t('login.signUpText')}}
                        <router-link to="/user/landing">{{$t('login.signUp')}}</router-link>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    <copyright></copyright>
    <form label-width="0px" class="demo-ruleForm needs-validation-verified-step2" novalidate>
      <div class="modal fade" id="authenticatorModalVerifiedStep2" tabindex="-1" role="dialog" aria-labelledby="authenticatorModalVerifiedStep2" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title" id="authenticatorModalLabel">
                {{$t('TwiceVerification.twiceVerification')}}
              </h4>
            </div>
            <div class="modal-body pt-5 pb-7">
              <div class="form-group">
                <small>{{$t('TwiceVerification.verificationCodeExplainLogin')}}</small><br><br>
                <label for="verificationCodeStep2">
                  <h5>{{$t('TwiceVerification.verificationCode')}}</h5>
                </label>
                <input class="form-control form-control-lg mt-2" v-model="verificationCode" id="verificationCodeStep2" required />
                <div class="invalid-feedback">
                  {{$t('TwiceVerification.verificationCodeRequired')}}
                </div>
              </div>
            </div>
            <div class="modal-footer pt-5 pb-3">
              <div class="col-6">
                <button type="button" class="btn btn-lg btn-outline-secondary" data-dismiss="modal">{{$t('modal.modalCancel')}}
                </button>
              </div>
              <div class="col-6 text-right">
                <button class="btn btn-lg btn-primary" type="submit" @click="verifiedStep2">{{$t('TwiceVerification.modalSubmit')}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <form label-width="0px" class="demo-ruleForm needs-validation-verified-step1" novalidate>
      <div class="modal fade" id="authenticatorModalVerifiedStep1" tabindex="-1" role="dialog" aria-labelledby="authenticatorModalVerifiedStep1" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title" id="authenticatorModalLabel">
                {{$t('TwiceVerification.bindAuthenticator')}}
              </h4>
            </div>
            <div class="modal-body">
              <h5>1.{{$t('TwiceVerification.SetVerificationCodeStep1')}}</h5>
              <h5>2.{{$t('TwiceVerification.SetVerificationCodeStep2')}}</h5>
              <div class="qrcode"><img v-bind:src="qrcodeURL" /></div>
              <div>{{$t('TwiceVerification.UrlCopy')}}
                <a href="javascript:void(0);" @click="copySecret" :title="$t('TwiceVerification.Copy')"><i class="fa fa-clone" aria-hidden="true"></i></a>
              </div>
              <input id="inputCom" class="form-control ml-3" style="width:auto" :value="secret" readonly>
              <div class="pt-3 pb-3">
                <h5>3.{{$t('TwiceVerification.SetVerificationCodeStep3')}}</h5>
              </div>
              <h5 class="col-8 col-md-6">{{$t('TwiceVerification.verificationCode')}}<input v-model="verificationCode" class="form-control" required id="verificationCodeStep1">
                <div class="invalid-feedback">
                  {{$t('TwiceVerification.verificationCodeRequired')}}
                </div>
              </h5>
            </div>
            <div class="modal-footer pt-5 pb-5">
              <div class="col-6">
                <button type="button" class="btn btn-lg btn-outline-secondary" data-dismiss="modal">{{$t('modal.modalCancel')}}
                </button>
              </div>
              <div class="col-6 text-right">
                <button class="btn btn-lg btn-primary" type="submit" @click="verifiedStep1">{{$t('TwiceVerification.modalSubmit')}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <form label-width="0px" class="demo-ruleForm needs-validation-forget-password" novalidate>
      <div class="modal fade" id="forgetPasswordModal" tabindex="-1" role="dialog" aria-labelledby="forgetPasswordModal" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title" id="forgetPasswordModalLabel">
                {{$t('forgotPassword.modalTitle')}}
              </h4>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label for="forgetEmail">{{$t('login.email')}}</label>
                <input class="form-control form-control-lg" v-model="forgetPasswordEmail" type="email" id="forgetEmail" required />
                <div class="invalid-feedback">
                  {{$t('login.emailRequired')}}
                </div>
              </div>
            </div>
            <div class="modal-footer pt-5 pb-5">
              <div class="col-6">
                <button type="button" class="btn btn-lg btn-outline-secondary" data-dismiss="modal">{{$t('modal.modalCancel')}}
                </button>
              </div>
              <div class="col-6 text-right">
                <button class="btn btn-lg btn-primary" type="submit" @click="forgetPassword">{{$t('TwiceVerification.modalSubmit')}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<style src="../../../static/css/dashboard.css" />

<script type="text/javascript">
import QRCode from 'qrcode'
import { NmsClient, RestCfg, Env } from '../../scripts/AllExport'
import { messageAlert } from '../../../static/js/common.js'
import copyright from './copyright'
import crypto from 'crypto'
import Cookies from 'js-cookie'
let loginReqType = 'user-login'
let forgetPasswordReqType = 'user-forget-password'
export default {
  components: { copyright },
  data: function () {
    return {
      message: '',
      email: '',
      forgetPasswordEmail: '',
      verificationCode: '',
      password: '',
      qrcodeURL: '',
      secret: '',
      nextUrl: '/user/top'
    }
  },
  mounted() {
    if (typeof this.$route.params.nextUrl !== 'undefined') this.nextUrl = this.$route.params.nextUrl
    $('#authenticatorModalVerifiedStep2').on('hidden.bs.modal', (event) => {
      this.verificationCode = ''
      if ($('.needs-validation-verified-step2')[0] !== undefined) {
        $('.needs-validation-verified-step2')[0].classList.remove('was-validated')
      }
    })
    $('#authenticatorModalVerifiedStep1').on('hidden.bs.modal', (event) => {
      this.qrcodeURL = ''
      this.verificationCode = ''
      this.secret = ''
      if ($('.needs-validation-verified-step1')[0] !== undefined) {
        $('.needs-validation-verified-step1')[0].classList.remove('was-validated')
      }
    })
    $('#forgetPasswordModal').on('hidden.bs.modal', (event) => {
      this.forgetPasswordEmail = ''
      if ($('.needs-validation-forget-password')[0] !== undefined) {
        $('.needs-validation-forget-password')[0].classList.remove('was-validated')
      }
    })
  },
  methods: {
    login() {
      let form = $('.needs-validation')[0]

      form.onsubmit = (event) => {
        event.preventDefault()
        if (form.checkValidity()) {
          let password = this.createHash(this.password)
          NmsClient.send(
            RestCfg.POST,
            {
              'reqType': loginReqType,
              'email': this.email,
              'password': password,
              'step': 1
            },
            this.loginResult,
            this.loginVerificationFailed
          )
        }
        form.classList.add('was-validated')
      }
    },
    loginVerificationFailed(response) {
      let result = response.body.errorInfoList
      if (result !== null && response.body.resultCode === '1001') {
        messageAlert(result[0].message)
      } else {
      // ログイン失敗
        this.message = this.$t('login.message')
        this.showMessage = true
      }
    },
    loginResult(response) {
      this.message = ''
      let result = response.resultInfo
      if (result.status === 0) {
        this.secret = result.secret
        QRCode.toDataURL(result.uri)
          .then(url => {
            this.qrcodeURL = url
          })
          .catch(err => {
            console.error(err)
          })
        $('#authenticatorModalVerifiedStep1').modal('show')
      } else if (result.status === 1) {
        $('#authenticatorModalVerifiedStep2').modal('show')
      }
    },
    verifiedStep1() {
      let form = $('.needs-validation-verified-step1')[0]

      form.onsubmit = (event) => {
        event.preventDefault()
        if (form.checkValidity()) {
          let password = this.createHash(this.password)
          NmsClient.send(
            RestCfg.POST,
            {
              'reqType': loginReqType,
              'email': this.email,
              'password': password,
              'verificationCode': this.verificationCode,
              'step': 2
            },
            this.loginVerifiedResult,
            null
          )
        }
        form.classList.add('was-validated')
      }
    },
    verifiedStep2() {
      let form = $('.needs-validation-verified-step2')[0]

      form.onsubmit = (event) => {
        event.preventDefault()
        if (form.checkValidity()) {
          let password = this.createHash(this.password)
          NmsClient.send(
            RestCfg.POST,
            {
              'reqType': loginReqType,
              'email': this.email,
              'password': password,
              'verificationCode': this.verificationCode,
              'step': 2
            },
            this.loginVerifiedResult,
            null
          )
        }
        form.classList.add('was-validated')
      }
    },
    loginVerifiedResult(response) {
      let result = response.resultInfo
      $('#authenticatorModalVerifiedStep1').modal('hide')
      $('#authenticatorModalVerifiedStep2').modal('hide')
      Cookies.set('tokenId', result.token, { path: '/', expires: Env.COOKIES_TTL })
      localStorage.userEmail = result.userEmail
      this.$router.push({ path: this.nextUrl })
    },
    forgetPassword() {
      let form = $('.needs-validation-forget-password')[0]

      form.onsubmit = (event) => {
        event.preventDefault()
        if (form.checkValidity()) {
          NmsClient.send(
            RestCfg.POST,
            {
              'reqType': forgetPasswordReqType,
              'email': this.forgetPasswordEmail,
              'type': 1
            },
            () => {
              this.$alert(this.$t('forgotPassword.sendEmailSuccess'), this.$t('forgotPassword.message'), {
                confirmButtonText: 'OK',
                lockScroll: false,
                closeOnClickModal: true,
                callback: action => {
                  $('#forgetPasswordModal').modal('hide')
                }
              })
            },
            null
          )
        }
        form.classList.add('was-validated')
      }
    },
    createHash(password) {
      // パスワードハッシュ化
      let md5 = crypto.createHash('md5')
      let md5Sum = md5.update(password)
      return md5Sum.digest('Base64')
    },
    changeLanguage(language) {
      let setLanguage = language
      Cookies.set('language', setLanguage, { path: '/', expires: Env.COOKIES_TTL })
      this.$i18n.locale = setLanguage
    },
    copySecret() {
      let inputCom = document.getElementById('inputCom')
      inputCom.select()
      document.execCommand('copy')
      this.$message.success(this.$t('TwiceVerification.CopySuccess'), 0)
    }
  }
}
</script>
<style scoped>
.entire-screen{
  min-height:calc(100vh - 72px)
}
.form-group {
    margin-bottom: 0rem;
    height: 108px;
}
.qrcode{
  height:212px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/login.vue